// assets
import { IconBrandGithub } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

// ==============================|| REPOSITORIES MENU ITEM ||============================== //

const icons = {
  IconBrandGithub
};

const repositories: NavItemType = {
  id: 'repositories',
  title: 'repositories',
  icon: icons.IconBrandGithub,
  type: 'group',
  url: '/pr-review-agents'
};

export default repositories;
